import Loadable from "react-loadable";
import { EmptyComponent } from "../common/EmptyComponent.js";

export const GreetingBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/greeting" */
      "./components/GreetingBox/GreetingBox.js"
    ),
  loading: EmptyComponent
});

export const BalanceBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/balance" */ "./components/BalanceBox/BalanceBox.js"
    ),
  loading: EmptyComponent
});

export const NotificationBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/notification" */ "./components/NotificationBox/NotificationBox.js"
    ),
  loading: EmptyComponent
});

export const LoyaltyIndicatorBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/loyalty" */ "../LoyaltyIndicator/LoyaltyIndicatorBox.js"
    ),
  loading: EmptyComponent
});

export const ControlCenterBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/control-center" */ "./components/ControlCenter/ControlCenterBox.js"
    ),
  loading: EmptyComponent
});

export const HistoryBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/history" */ "./components/HistoryBox/HistoryBox.js"
    ),
  loading: EmptyComponent
});

export const UsefulLinkBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/useful-links" */ "./components/UsefulLinksBox/UsefulLinksBox.js"
    ),
  loading: EmptyComponent
});

export const LinkItemChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/link-item" */ "./components/LinkItem/LinkItem.js"
    ),
  loading: EmptyComponent
});

export const LinksBoxChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/links" */ "./components/LinksBox/LinksBox.js"
    ),
  loading: EmptyComponent
});

export const BiometricLinkChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "box/biometrics-link" */ "./components/BiometricLink/BiometricLink.js"
    ),
  loading: EmptyComponent
});
